import { render, staticRenderFns } from "./DefaultDocumentViewSelectionModal.vue?vue&type=template&id=dff0d584&scoped=true&"
import script from "./DefaultDocumentViewSelectionModal.vue?vue&type=script&lang=js&"
export * from "./DefaultDocumentViewSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDocumentViewSelectionModal.vue?vue&type=style&index=0&id=dff0d584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff0d584",
  null
  
)

export default component.exports